export default __webpack_public_path__ + "static/kreativa-erbjudanden-hos-nya-casino-e73869ba3ec55806a29477dc11adf445.jpg";